/*
 * Graphical indicator representing the completion status of a wizard page
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import {
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
    selector: 'reporter-completion-indicator',
    templateUrl: './completion-indicator.component.html',
    styleUrls: ['./completion-indicator.component.scss'],
    standalone: false
})
export class CompletionIndicatorComponent implements OnInit {

  @Input() completionIndex = 0;
  @Input() requiredCompleted = false;
  @Input() requiredCount = 0;
  @Input() pageIndex = Math.random();
  @Input() isCurrentPage = false;
  @Input() isSummaryPage = false;

  readonly ratio = 17 * 2 * 3.1415;

  constructor() { }

  ngOnInit(): void {
  }

  get id() {
    return `indicator-${ this.pageIndex }`;
  }

}
